<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between justify-content-md-end align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']" *ngIf="!isDesktop"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto dirI text-white">
            
            <span class="">

                 ثبت و ویرایش خطوط  

                {{ bTaxi_Line ? 'تاکسیرانی' : 'اتوبوسرانی' }}
                           
            </span>
            
        </a>

    </div>
    
</div>

<div class="d-flex container justify-content-around flex-wrap dirI col-md-5 mx-auto col-12">
    <p class="border-bottom border-danger pointer my-1" id="line" (click)="tbaIndex('line')">خطوط</p>
    <p class="pointer my-1" id="station" (click)="tbaIndex('station')">ایستگاه ها</p>

</div>
<!-- <hr class="my-0" /> -->
<div id="line-div" class="d-flex flex-wrap ">

    <div class="table-responsive dirI rounded-3  my-2  col-md-6 mx-auto col-12 ">
        <div class="d-flex flex-wrap justify-content-between mb-2 align-items-end">
            <div class="col-4">

                <label>نام شهر</label>
                <ng-autocomplete [disabled]="isediteMod" [initialValue]="txt" [data]="cityData"
                    [searchKeyword]="keywordCity" placeholder="جستجو" (inputCleared)="clearLine()"
                    (selected)='selectCity($event)' [itemTemplate]="itemTemplate2"
                    [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>

                <ng-template #itemTemplate2 let-item>
                    <a [innerHTML]="item.strCityName"></a>
                </ng-template>

                <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                </ng-template>

            </div>
            <div class="col-4">
                <label>جستجو</label>
                <input class="form-control" placeholder="جستجو" (keyup)="filterLine($event.target)" id="search-line">

            </div>
            <div class="">
                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#Add-line-modal">ثبت خط
                    جدید</button>

            </div>
        </div>
        <div class="tab-index-h">
            <table class="table table-striped border border-2 rounded-3 ">
                <thead>
                    <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                    <tr class="">
                        <th class="text-center">ردیف</th>
                        <th class="text-center pointer" (click)="sortLineName()">نام خط</th>
                        <th class="text-center pointer" (click)="sortLineCode()">کد خط</th>
                        <th class="text-center pointer">تعرفه</th>
                        <th class="text-center">عملیات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="" *ngFor="let item of lineData; let i=index">
                        <td class="text-center">{{i+1|faNum}}</td>
                        <td class="text-center ">{{item.strBusLineName|faNum}}</td>
                        <td class="text-center "> {{item.strBusLineCode|faNum}}</td>
                        <td class="text-center "> {{ item.iFee | number |faNum }}</td>
                        <td class="dirl f22 text-center pointer">
                            <i class="fa fa-edit text-warning mx-1" title="ویرایش" (click)="editeLineModal(item,i)"
                                data-bs-toggle="modal" data-bs-target="#Add-line-modal"></i>
                            <i class="fa fa-road text-dark mx-1" title="کریدور خط" (click)="openCorridor(item,i)"></i>
                            <i class="fa fa-bus text-success mx-1" [title]="bTaxi_Line ? 'اختصاص تاکسی' : 'اختصاص اتوبوس'"
                                (click)="getBusStation(item.iBusLine)" data-bs-toggle="modal"
                                data-bs-target="#bus-modal"></i>
                            <i class="fa fa-fa text-primary mx-1" title="اختصاص ایستگاه"
                                (click)="getLineStation(item.iBusLine)" data-bs-toggle="modal"
                                data-bs-target="#line-station-modal"></i>
                            <i class="fa fa-trash text-danger mx-1" title="حذف" (click)="deleteLine(item.iBusLine)"></i>

                        </td>
                    </tr>

                </tbody>
            </table>
        </div>


    </div>
</div>
<div id="station-div" class="d-flex d-none">
    <div class="table-responsive dirI rounded-3  my-2  col-md-5 mx-auto col-12">
        <div class="d-flex flex-wrap justify-content-between mb-2 align-items-end">
            <div class="col-4">

                <!-- <option>انتخاب کنید</option>
<option  *ngFor="let item of cityData" value="{{item.strCity}}">{{item.strCityName}}</option> -->
                <label>نام شهر</label>

                <ng-autocomplete [disabled]="isediteMod" [initialValue]="txt" [data]="cityData"
                    [searchKeyword]="keywordCity" (inputCleared)="clearStation()" placeholder="جستجو"
                    (selected)='selectCityStation($event)' [itemTemplate]="itemTemplate2"
                    [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>

                <ng-template #itemTemplate2 let-item>
                    <a [innerHTML]="item.strCityName"></a>
                </ng-template>

                <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                </ng-template>


            </div>
            <div class=" col-4">
                <label>جستجو</label>
                <input class="form-control" placeholder="جستجو" (keyup)="filterStation($event.target)"
                    id="search-station">

            </div>
            <div class="">
                <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#Add-station-modal"
                    (click)="newOpenMap()">
                    ثبت ایستگاه جدید
                </button>

            </div>
        </div>
        <div class="tab-index-h">
            <table class="table table-striped border border-2 rounded-3 ">
                <thead>
                    <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                    <tr class="">
                        <th class="text-center">ردیف</th>
                        <th class="text-center pointer" (click)="sortBusStopName()">نام ایستگاه </th>
                        <th class="text-center pointer" (click)="strBusStopCode()">کد ایستگاه </th>
                        <th class="text-center pointer" (click)="strBusStopFake()">نوع ایستگاه </th>

                        <th class="text-center">عملیات </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of stationData; let i=index">
                        <td class="text-center ">{{i+1|faNum}}</td>
                        <td class="text-center ">{{item.strBusStopName|faNum}}</td>
                        <td class="text-center "> {{item.strBusStopCode|faNum}}</td>
                        <td class="text-center "> {{item.bFake==true?"مجازی":"واقعی"}}</td>
                        <td class="dirl f22 text-center pointer">
                            <i class="fa fa-edit text-warning mx-1" title="ویرایش" (click)="editeStationModal(item,i)"
                                data-bs-toggle="modal" data-bs-target="#Add-station-modal"></i>
                            <i class="fa fa-trash text-danger mx-1" title="حذف"
                                (click)="deleteStation(item.iBusStop)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<!--Add-line-Modal-->
<div class="modal fade" id="Add-line-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title">ثبت خط جدید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body dirI">

                <div class="d-flex flex-wrap  justify-content-around " [formGroup]="saveLineForm">

                    <div class="col-5 mb-2">
                        <label class="mb-2  w-100 text-start" maxlength="10">کد خط</label>

                        <input class="form-control dirl text-end " formControlName="strBusLineCode">
                    </div>

                    <div class="col-5 mb-2">
                        <label class="mb-2 dirI w-100 text-start">نام خط</label>

                        <input class="form-control  dirI " maxlength="40" formControlName="strBusLineName">
                    </div>

                    <div class="col-5 mb-2">

                        <label class="mb-2 dirI w-100 text-start"> تعرفه خط(ریال) </label>

                        <input class="form-control dirI " formControlName="iFee">

                    </div>

                    <div class="col-5 mb-2">

                        <label class="mb-2 dirI w-100 text-start"> حداقل طول خط(کیلومتر) </label>

                        <input class="form-control dirI " formControlName="fMinLength">

                    </div>

                    <div class="col-5 mb-2">
                        <label class="mb-2 dirI w-100 text-start">نام شهر</label>

                        <ng-autocomplete [disabled]="isediteMod" [data]="cityData" [searchKeyword]="keywordCity"
                            placeholder="جستجو" (selected)='selectCityLineAdd($event)' [itemTemplate]="itemTemplate2"
                            [notFoundTemplate]="notFoundTemplate">
                        </ng-autocomplete>

                        <ng-template #itemTemplate2 let-item>
                            <a [innerHTML]="item.strCityName"></a>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                        </ng-template>
                    </div>

                    <div class="col-5 mb-2">

                        <label class="mb-2 dirI w-100 text-start">کد رنگ</label>

                        <input type="color" id="favcolor" name="favcolor" class="w-100 h-50" formControlName="strColor">

                    </div>

                </div>

            </div>

            <div class="modal-footer dirI">

                <button type="button" class="btn btn-primary" *ngIf="!editeLineData" (click)="saveLine()">ثبت</button>

                <button type="button" class="btn btn-primary" *ngIf="editeLineData" (click)="editeLine()">

                    ویرایش
                
                </button>

            </div>

        </div>

    </div>

</div>
<!--Add-station-Modal-->
<div class="modal fade" id="Add-station-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title">ثبت ایستگاه جدید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body dirI">
                <div class="d-flex flex-wrap  justify-content-around " [formGroup]="saveStationForm">

                    <div class="col-5">
                        <label class="mb-2 dirI w-100 text-start">نام ایستگاه</label>

                        <input class="form-control  dirI" formControlName="strBusStopName" maxlength="40">
                    </div>
                    <div class="col-5">
                        <label class="mb-2  w-100 text-start">کد ایستگاه</label>

                        <input class="form-control text-end " formControlName="strBusStopCode" maxlength="10">
                    </div>

                    <div class="col-5">
                        <label class="mb-2 dirI w-100 text-start">نام شهر</label>

                        <ng-autocomplete [disabled]="isediteMod" [data]="cityData" [searchKeyword]="keywordCity"
                            placeholder="جستجو" (selected)='selectCityStationAdd($event)' [itemTemplate]="itemTemplate2"
                            [notFoundTemplate]="notFoundTemplate">
                        </ng-autocomplete>

                        <ng-template #itemTemplate2 let-item>
                            <a [innerHTML]="item.strCityName"></a>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                            <div [innerHTML]="notFound"></div>
                        </ng-template>
                        <div class="col-12 d-flex flex-row">
                            <label for="fack">ایستگاه مجازی</label>
                            <input type="checkbox" class="form-check" id="fack" formControlName="bFake">
                        </div>

                    </div>
                    <div class="col-5">
                        <label class="mb-2 dirI w-100 text-start">توضیحات</label>

                        <textarea class="form-control  dirI" formControlName="strComment" maxlength="300">
                        </textarea>
                    </div>
                </div>
            </div>
            <hr class="mb-0">


            <!-- <img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()" class="bg-third index p-2 circel-2 my-1 text-center pointer text-white icon-Img"> -->
            <div id="test" class="position-sticky w-100" style="height: 300px;">
                <div class="position-absolute" id="map_tooltip" data-bs-html="true">
                </div>

            </div>

            <div class="modal-footer dirI d-flex justify-content-between">
                <button class="btn btn-warning w-fit" title="تغییر نوع نقشه" (click)="changeTail()">تغییر نوع نقشه <i
                        class="fa fa-map-marker"></i></button>
                <button type="button" class="btn btn-primary" *ngIf="!editeStationData"
                    (click)="saveStation()">ثبت</button>
                <button type="button" class="btn btn-primary" *ngIf="editeStationData"
                    (click)="editeStation()">ویرایش</button>
            </div>
        </div>
    </div>
</div>
<!--bus-station-modal-->
<div class="modal fade" id="line-station-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title">ایستگاه های خط</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="col-12 dirI d-flex justify-content-around align-items-end">
                    <div class="col-md-4 col-12">
                        <label class="control-label mb-1">نام ایستگاه</label>
                        <div class="">
                            <ng-autocomplete [initialValue]="txt" [data]="fullStationData" [searchKeyword]="keyword"
                                placeholder="جستجو" (selected)='selectEvent($event)' [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate">
                            </ng-autocomplete>

                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item.strBusStopName+'-'+item.strBusStopCode"></a>
                            </ng-template>

                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-md-4 col-12" [formGroup]="AddStationToLineForm">
                        <label class="control-label mb-1">ردیف</label>
                        <input class="form-control" type="number" formControlName="iIndex">
                    </div>
                    <div class="col-md-3 col-12">
                        <button class="btn btn-primary" (click)="addStationToLine()">ثبت</button>
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-start dirI mt-2">
                    <div class="col-8">
                        <input type="text" class="form-control" placeholder="جستجو" (keyup)="search($event.target)">

                    </div>

                </div>
                <div class="table-responsive dirI rounded-3  my-2 overflow-auto" style="max-height: 70vh;">

                    <table class="table table-striped border border-2 rounded-3">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">

                                <th class="text-center">ردیف</th>
                                <th class="text-center">نام خط</th>
                                <th class="text-center">کد خط</th>
                                <th class="text-center">نام ایستگاه</th>
                                <th class="text-center">کد ایستگاه</th>
                                <th class="text-center">ردیف ایستگاه</th>
                                <th class="text-center">عملیات</th>



                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of lineStationData; let i=index">
                                <td class="text-center">{{i+1|faNum}}</td>

                                <td class="text-center ">{{item.strBusLineName|faNum}}</td>
                                <td class="text-center "> {{item.strBusLineCode|faNum}}</td>
                                <td class="text-center "> {{item.strBusStopName|faNum}}</td>
                                <td class="text-center "> {{item.strBusStopCode|faNum}}</td>
                                <td class="text-center "> {{item.iIndex|faNum}}</td>
                                <td class="dirl f22 text-center ">

                                    <i title="حذف" class="fa fa-trash text-danger mx-1 pointer"
                                        (click)="deleteStationFromLine(item.iBusLine,item.iBusStop)"></i>

                                </td>



                            </tr>

                        </tbody>
                    </table>

                </div>

            </div>


        </div>
    </div>
</div>
<!--bus-modal-->
<div class="modal fade" id="bus-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="carModalLabel">اتوبوس های خط</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body ">
                <div class="d-flex mb-2 flex-wrap dirI">
                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">
                        <input type="text" id="filterModal" class="form-control" autocomplete="one-time-code"
                            (keyup)="filterBus($event.target)" placeholder="جستجو ">
                    </div>

                </div>


                <div class="table-responsive dirI rounded overflow-scroll" style="max-height: 70vh;">
                    <table class="table table-bordered rounded rounded-3" id="">
                        <thead class="bg-secondary">
                            <tr class="text-center f14">
                                <th scope="col" class="text-white">#</th>
                                <th scope="col" class="text-white pointer" (click)="filterAdd()">اختصاص</th>
                                <th scope="col" class="text-white">نام راننده</th>
                                <th scope="col" class="text-white">کد شناسایی خودرو</th>
                                <th scope="col" class="text-white">شماره موبایل راننده</th>
                                <th scope="col" class="text-white">حوزه خدمت</th>
                                <th scope="col" class="text-white">گروه خودرو</th>
                                <th scope="col" class="text-white">پلاک</th>
                                <th scope="col" class="text-white">تاریخ پایان اعتبار</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center f12" *ngFor="let item of assignBusList;let i=index">
                                <th class="text-secondary">{{i+1}}</th>
                                <th class="text-secondary">
                                    <input class="form-check-input" type="checkbox" value="" checked
                                        *ngIf="item.bHas!=0" (click)="addOrRemoveCar(item.strUnitID)">
                                    <input class="form-check-input" type="checkbox" value="" *ngIf="item.bHas==0"
                                        (click)="addOrRemoveCar(item.strUnitID)">
                                </th>
                                <th scope="col" class="text-secondary">{{item.strFullName}}</th>
                                <th scope="col" class="text-secondary">{{item.strUnitID}}</th>
                                <th scope="col" class="text-secondary">{{item.strSystemUser_strMobile}}</th>
                                <th scope="col" class="text-secondary">{{item.strMobileDomain_strComment}}</th>
                                <th scope="col" class="text-secondary">{{item.strMobileGroup_strComment}}</th>
                                <th scope="col" class="text-secondary">{{item.strVehicleNo}}</th>
                                <th scope="col" class="text-secondary">{{item.strValidDate}}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="Add-Corridor-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ویرایش کریدور </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body dirI">

                <div id="corridor" class="position-sticky w-100 h-100">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button class="btn btn-warning w-fit" (click)="changeTail()">

                    تغییر نوع نقشه

                    <i class="fa fa-map-marker"></i>

                </button>

                <button type="button" class="btn btn-primary px-4" (click)="editCorridor()">

                    ویرایش

                </button>

            </div>

        </div>

    </div>

</div>